import React from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { CAprovinces, genderOptions } from '../helper'
import UDFInfo from './udfInfo'

const RequiredMark = () => <span className="required-marker" aria-hidden="true"> *</span>

function AthleteInfo(props) {

  const { disabled, changeState, invalidFieldIds = [], customFields = null, selected_athlete = null } = props
  const hasError = (id) => invalidFieldIds.includes(id)

  return (
    <div className="white-text enrolment-participant-block">
      <Row>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_first_name") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>First Name<RequiredMark /></ControlLabel>
            <FormControl className="opaque-grey" name="athlete_first_name" type="text" id="athlete_first_name" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_first_name', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_last_name") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Last Name<RequiredMark /></ControlLabel>
            <FormControl className="opaque-grey" name="athlete_last_name" type="text" id="athlete_last_name" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_last_name', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_gender") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Gender<RequiredMark /></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_gender" componentClass="select" id="athlete_gender" disabled={disabled} onChange={(e) => changeState('athlete_gender', e.target.value)}>
              {genderOptions}
            </FormControl>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <ControlLabel className={hasError("athlete_birth_date") ? "enrolment-invalid-label" : ""}>Date of Birth<RequiredMark /></ControlLabel>
          <FormGroup className={`black-text ${hasError("athlete_birth_date") ? "enrolment-invalid-field" : ""}`}>
            <DatePicker className="opaque-grey form-control" selected={props.athlete_birth_date} placeholderText="MM/DD/YYYY" showYearDropdown onChange={(date) => props.handleAthleteBirthdateChange(date, 'athlete_birth_date')} disabled={disabled}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_email") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>E-mail <span style={{fontSize: ".8rem" }}>(Optional)</span></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_email" type="text" id="athlete_email" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_email', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_phone") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Phone<RequiredMark /></ControlLabel>
            <FormControl className="opaque-grey" name="athlete_phone" type="text" id="athlete_phone" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_phone', e.target.value)}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <FormGroup className={hasError("athlete_address") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Address<RequiredMark /></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_address" type="text" id="athlete_address" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_address', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_city") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>City<RequiredMark /></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_city" type="text" id="athlete_city" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_city', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_province") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Province/State<RequiredMark /></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_province" type="text" id="athlete_province" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_province', e.target.value)}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup className={hasError("athlete_postal_code") ? "enrolment-invalid-field" : ""}>
            <ControlLabel>Post Code<RequiredMark /></ControlLabel>
            <FormControl  className="opaque-grey" name="athlete_postal_code" type="text" id="athlete_postal_code" placeholder="" disabled={disabled} onChange={(e) => changeState('athlete_postal_code', e.target.value)}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
      <Col lg={6} sm={2}>
      <FormGroup>
          <ControlLabel>Additional Notes</ControlLabel>
          <FormControl  className="opaque-grey" name="athlete_parent_notes" componentClass="textarea" id="athlete_parent_notes" placeholder="Allergies, scheduling conflicts, etc." disabled={disabled} onChange={(e) => changeState('athlete_parent_notes', e.target.value)}/>
      </FormGroup>
      </Col>
      </Row>
      {customFields ? (
        <UDFInfo
          disabled={disabled}
          udfs={customFields}
          athlete={selected_athlete}
          changeState={changeState}
          invalidFieldIds={invalidFieldIds}
        />
      ) : null}
  </div>
  )
}

export default AthleteInfo
